import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { PlaceholderPage } from "Shared/Pages/PlaceholderPage";

export const TermsOfServicePage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <PlaceholderPage
      title={t(Resources.Legal.TermsOfService.Title)}
      body={t(Resources.Legal.Body)}
    />
  );
};
